import { trackUser } from '@api/tracking/client';
import type { ChecklistItemKey } from './hooks/use-checklist-store';

export const trackSeenEditorChecklist = () => {
  trackUser({
    event: 'Has seen editor checklist',
  });
};

export const trackCompletedEditorChecklistItem = (
  key: ChecklistItemKey,
  progress: number,
) => {
  trackUser({
    event: 'Completed editor checklist item',
    properties: {
      'item key': key,
      progress,
    },
  });
};

export const trackClickedEditorChecklistItem = (key: ChecklistItemKey) => {
  trackUser({
    event: 'Clicked editor checklist item',
    properties: {
      'item key': key,
    },
  });
};

export const trackToggledEditorChecklist = (isOpen: boolean) => {
  trackUser({
    event: 'Toggled editor checklist',
    properties: {
      state: isOpen ? 'opened' : 'closed',
    },
  });
};
